import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, isRef as _isRef, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-red-darken-4 text-caption"
};
const _hoisted_2 = {
    key: 0,
    class: "text-red-darken-4 text-caption"
};
import { ref, reactive, inject } from "vue";
import Timeslot from "@/model/Timeslot";
import { DayOfWeek, LocalTime } from "@js-joda/core";
import { useI18n } from "vue-i18n";
import { ProductServiceSymbol } from "@/InjectionSymbols";
import { validationRules } from "@/ValidationRules";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductTimeslotPanel',
    props: {
        timeslots: { type: Array, required: true },
        productId: { type: Number, required: true }
    },
    emits: ["onTimeslotUpdated"],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const productService = inject(ProductServiceSymbol);
        const props = __props;
        const emits = __emit;
        const dialog = ref(false);
        let editSlot = reactive(new Timeslot());
        let customResourceOccupation = ref(false);
        const formRef = ref();
        const timePickerRules = {
            minutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
        };
        function localTimeToDate(time) {
            const date = new Date();
            date.setHours(time.hour(), time.minute(), 0, 0);
            return date;
        }
        function editTimeslot(item) {
            editSlot.assign(item);
            customResourceOccupation.value = item.resourceOccupationStart.compareTo(item.startTime) != 0
                || item.resourceOccupationEnd.compareTo(item.endTime) != 0;
            dialog.value = true;
        }
        function removeTimeslot(item) {
            productService.deleteTimeslot(item.id)
                .then(() => {
                emits("onTimeslotUpdated");
            });
        }
        function closeDialog() {
            editSlot = reactive(new Timeslot());
            dialog.value = false;
        }
        function saveEdit() {
            formRef.value.resetValidation();
            formRef.value.validate().then((result) => {
                const endAfterStart = isAfterTime(editSlot.endTime, editSlot.startTime);
                const occEndAfterStart = !customResourceOccupation.value || isAfterTime(editSlot.resourceOccupationEnd, editSlot.resourceOccupationStart);
                if (result.valid && endAfterStart && occEndAfterStart) {
                    productService.saveTimeslot(props.productId, editSlot)
                        .then(() => {
                        emits("onTimeslotUpdated");
                        closeDialog();
                    });
                }
            });
        }
        function onStartTimeChange(value) {
            editSlot.startTime = LocalTime.parse(value.toLocaleTimeString());
            if (!customResourceOccupation.value) {
                editSlot.resourceOccupationStart = editSlot.startTime;
            }
        }
        function onEndTimeChange(value) {
            editSlot.endTime = LocalTime.parse(value.toLocaleTimeString());
            if (!customResourceOccupation.value) {
                editSlot.resourceOccupationEnd = editSlot.endTime;
            }
        }
        function onResourceOccupationStartChange(value) {
            editSlot.resourceOccupationStart = LocalTime.parse(value.toLocaleTimeString());
        }
        function onResourceOccupationEndChange(value) {
            editSlot.resourceOccupationEnd = LocalTime.parse(value.toLocaleTimeString());
        }
        function onCustomResourceOccupationChange(value) {
            customResourceOccupation.value = value;
            if (!value) {
                editSlot.resourceOccupationStart = editSlot.startTime;
                editSlot.resourceOccupationEnd = editSlot.endTime;
            }
        }
        function isAfterTime(time1, time2) {
            return time1.compareTo(time2) >= 0;
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_select = _resolveComponent("v-select");
            const _component_vc_date_picker = _resolveComponent("vc-date-picker");
            const _component_v_switch = _resolveComponent("v-switch");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createBlock(_component_v_container, { class: "d-flex flex-wrap v-col-12" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                        items: __props.timeslots,
                        headers: [
                            { title: ' Wochentage', key: 'weekdays' },
                            { title: 'Startzeit', key: 'startTime' },
                            { title: 'Endzeit', key: 'endTime' },
                            { title: 'Ressourcenbelegung', key: 'resourceOccupation' },
                            { title: 'Aktionen', key: 'actions', sortable: false },
                        ],
                        class: "w-100 mt-4",
                        "items-per-page": -1
                    }, {
                        [`header.actions`]: _withCtx(() => [
                            _createVNode(_component_v_dialog, {
                                modelValue: dialog.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((dialog).value = $event)),
                                "max-width": "500px"
                            }, {
                                activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_container, { class: "d-flex v-col-12 pa-0 ma-0 justify-center" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_btn, _mergeProps(props, { "data-cy": "createTimeslot" }), {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { color: "white" }, {
                                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                            _createTextVNode("mdi-plus")
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 2
                                            }, 1040)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_card_title, null, {
                                                default: _withCtx(() => [
                                                    (_unref(editSlot).id === 0)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode("Neuer Timeslot")
                                                        ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode("Timeslot bearbeiten")
                                                        ], 64))
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_card_text, { class: "" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_form, {
                                                        ref_key: "formRef",
                                                        ref: formRef,
                                                        class: "d-flex flex-wrap justify-space-between"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_select, {
                                                                class: "v-col-12 pa-0",
                                                                modelValue: _unref(editSlot).weekdays,
                                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editSlot).weekdays) = $event)),
                                                                items: _unref(DayOfWeek).values().map(day => ({ value: day.toString(), title: _unref(t)(day.toString()) })),
                                                                label: "Wochentage",
                                                                multiple: "",
                                                                variant: "outlined",
                                                                rules: [_unref(validationRules).required],
                                                                "data-cy": "weekdays-select"
                                                            }, null, 8, ["modelValue", "items", "rules"]),
                                                            _createVNode(_component_v_container, { class: "v-col-5 ma-0 pa-0" }, {
                                                                default: _withCtx(() => [
                                                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-caption" }, "Startzeit", -1)),
                                                                    _createVNode(_component_vc_date_picker, {
                                                                        mode: "time",
                                                                        modelValue: localTimeToDate(_unref(editSlot).startTime),
                                                                        "hide-time-header": true,
                                                                        rules: timePickerRules,
                                                                        "onUpdate:modelValue": onStartTimeChange,
                                                                        is24hr: true
                                                                    }, null, 8, ["modelValue"])
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_container, { class: "v-col-5 d-flex flex-wrap ma-0 pa-0 justify-end" }, {
                                                                default: _withCtx(() => [
                                                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "v-col-12 pa-0 ma-0 text-caption text-end" }, "Endzeit", -1)),
                                                                    _createVNode(_component_vc_date_picker, {
                                                                        mode: "time",
                                                                        modelValue: localTimeToDate(_unref(editSlot).endTime),
                                                                        "hide-time-header": true,
                                                                        rules: timePickerRules,
                                                                        "onUpdate:modelValue": onEndTimeChange,
                                                                        is24hr: true
                                                                    }, null, 8, ["modelValue"]),
                                                                    (!isAfterTime(_unref(editSlot).endTime, _unref(editSlot).startTime))
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Endzeit muss nach Startzeit liegen"))
                                                                        : _createCommentVNode("", true)
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createVNode(_component_v_switch, {
                                                                modelValue: _unref(customResourceOccupation),
                                                                "onUpdate:modelValue": [
                                                                    _cache[1] || (_cache[1] = ($event) => (_isRef(customResourceOccupation) ? (customResourceOccupation).value = $event : customResourceOccupation = $event)),
                                                                    onCustomResourceOccupationChange
                                                                ],
                                                                color: "green",
                                                                label: "Abweichende Belegungszeit für Ressourcen?"
                                                            }, null, 8, ["modelValue"]),
                                                            (_unref(customResourceOccupation))
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createVNode(_component_v_container, { class: "v-col-5 ma-0 pa-0" }, {
                                                                        default: _withCtx(() => [
                                                                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-caption" }, "Startzeit", -1)),
                                                                            _createVNode(_component_vc_date_picker, {
                                                                                mode: "time",
                                                                                modelValue: localTimeToDate(_unref(editSlot).resourceOccupationStart),
                                                                                "hide-time-header": true,
                                                                                rules: timePickerRules,
                                                                                "onUpdate:modelValue": onResourceOccupationStartChange,
                                                                                is24hr: true
                                                                            }, null, 8, ["modelValue"])
                                                                        ]),
                                                                        _: 1
                                                                    }),
                                                                    _createVNode(_component_v_container, { class: "v-col-5 d-flex flex-wrap ma-0 pa-0 justify-end" }, {
                                                                        default: _withCtx(() => [
                                                                            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "v-col-12 pa-0 ma-0 text-caption text-end" }, "Endzeit", -1)),
                                                                            _createVNode(_component_vc_date_picker, {
                                                                                mode: "time",
                                                                                modelValue: localTimeToDate(_unref(editSlot).resourceOccupationEnd),
                                                                                "hide-time-header": true,
                                                                                rules: timePickerRules,
                                                                                "onUpdate:modelValue": onResourceOccupationEndChange,
                                                                                is24hr: true
                                                                            }, null, 8, ["modelValue"]),
                                                                            (!isAfterTime(_unref(editSlot).resourceOccupationEnd, _unref(editSlot).resourceOccupationStart))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Endzeit muss nach Startzeit liegen"))
                                                                                : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                    }, 512)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_card_actions, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_btn, {
                                                        onClick: saveEdit,
                                                        "data-cy": "save-timeslot"
                                                    }, {
                                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                            _createTextVNode("Speichern")
                                                        ])),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_btn, {
                                                        onClick: closeDialog,
                                                        "data-cy": "cancel-timeslot"
                                                    }, {
                                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                            _createTextVNode("Abbrechen")
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ]),
                        [`item.weekdays`]: _withCtx(({ item }) => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.weekdays, (day, index) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: index,
                                    size: "small",
                                    class: "me-1",
                                    color: "primary"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)(day.toString())), 1)
                                    ]),
                                    _: 2
                                }, 1024));
                            }), 128))
                        ]),
                        [`item.startTime`]: _withCtx(({ item }) => [
                            _createElementVNode("span", null, _toDisplayString(item.startTime.toString()), 1)
                        ]),
                        [`item.endTime`]: _withCtx(({ item }) => [
                            _createElementVNode("span", null, _toDisplayString(item.endTime.toString()), 1)
                        ]),
                        [`item.resourceOccupation`]: _withCtx(({ item }) => [
                            _createElementVNode("span", null, _toDisplayString(item.resourceOccupationStart.toString()) + " - " + _toDisplayString(item.resourceOccupationEnd.toString()), 1)
                        ]),
                        [`item.actions`]: _withCtx(({ item }) => [
                            _createVNode(_component_v_icon, {
                                color: "info",
                                size: "small",
                                onClick: ($event) => (editTimeslot(item))
                            }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                    _createTextVNode("mdi-pencil")
                                ])),
                                _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_icon, {
                                color: "error",
                                size: "small",
                                onClick: ($event) => (removeTimeslot(item))
                            }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createTextVNode("mdi-delete")
                                ])),
                                _: 2
                            }, 1032, ["onClick"])
                        ]),
                        bottom: _withCtx(({}) => _cache[12] || (_cache[12] = [])),
                        _: 2
                    }, 1032, ["items"])
                ]),
                _: 1
            }));
        };
    }
});
